// 系统参数配置
let host,webSocket, bsWebSocket,isSso,testbench;
switch (process.env.NODE_ENV) {
    case 'production':
        isSso= true;
        host = "/api";
        webSocket = "ws://121.40.72.134:81/api/ws";
        break;
    default:
        isSso= false;
        host = "http://192.168.1.82:83/api";
        webSocket = "ws://192.168.1.82:83/api/ws"
}


export default {
    isSso: isSso, //是否单点登录
    baseURL: host, // 接口地址
    webSocket: webSocket,
    timeout: 60000, // 请求超时
    systemName: 'DeviceManger',
    version: '1.0.0' // 应用版本,
}
